import theme from "@/styles/theme";
import { Container, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import Link from "@mui/material/Link";
import { StrapiImageAsset } from "../StrapiImageAsset";

export const AboutPartner = ({content}) => {
    return (
      <Container maxWidth="xl">
        <Grid
          container
          justifyContent="center"
          sx={{
            backgroundColor: `${
              content.background_color === "lightgrey"
                ? grey[100]
                : content.background_color === "white"
                ? theme.palette.common.white
                : ""
            } !important`,
            py: 3,
            [theme.breakpoints.up("md")]: {
              py: 6,
            },
          }}
        >
          <Grid item xs={10}>
            <Typography
              variant="h3"
              align="center"
              color="common.black"
              component="p"
              sx={{mb: 6}}
            >
              {content.headline}
            </Typography>
            <Typography>{content.description}</Typography>
            <Grid container spacing={3} justifyContent="center">
              {content.Partner.map((partner) => {
                return (
                  <Grid key={partner.id} item xs={6} sm={4} md={3} lg={2}>
                    <Link
                      href={partner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <StrapiImageAsset
                        strapiImageObject={partner.image}
                        layout="responsive"
                        objectFit="contain"
                        width={160}
                        height={90}
                      />
                    </Link>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
}

export default AboutPartner;